import React from "react";

import { FormattedMessage, useIntl } from "react-intl";

import VideoInfoModal from "@app/component/VideoInfoModal";
import BaseModalProps from "@app/component/VideoInfoModal/BaseModalProps";
import VideoDescription from "@app/component/VideoInfoModal/VideoDescription";

interface Props extends BaseModalProps {}

const VideoTutorialModal: React.FC<Props> = ({ ...props }) => {
  const intl = useIntl();
  return (
    <VideoInfoModal
      actionButtonTitle={intl.formatMessage({
        id: "integrations.videoTutorial.footer.gotIt",
        defaultMessage: "Got it!",
        description: "Text of GOT IT button",
      })}
      moreInfoButtonTitle={intl.formatMessage({
        id: "integrations.videoTutorial.footer.instructions",
        defaultMessage: "Step-by-step instructions",
        description: "Text of information link button",
      })}
      resourceLink="https://support.mapmycustomers.com/hc/en-us/articles/360053375574#h_01F0SR86D7Y5T60MH3BS8PE5E1"
      title={intl.formatMessage({
        id: "integrations.videoTutorial.title",
        defaultMessage: "Integrations Tutorial",
        description: "Title Group field info modal",
      })}
      videoId="521531343"
      {...props}
    >
      <VideoDescription
        title={intl.formatMessage(
          {
            id: "integrations.videoTutorial.paragraph",
            defaultMessage:
              "In this video, we'll teach your how to set up a one-way integration from your CRM into Map My Customers. Interested in two-way and custom sync? Inquire about <link>Advanced Syncs</link>. In the above video, we'll discuss the following:",
            description: "Text of paragraph of Import video tutorial",
          },
          {
            link: (linkText: string) => (
              <a
                href="https://share.hsforms.com/1vG9XJwa3Sk2lWljCDHV50Q3is1h"
                rel="noreferrer noopener"
                target="_blank"
              >
                {linkText}
              </a>
            ),
          }
        )}
      >
        {[
          <FormattedMessage
            id="integrations.videoTutorial.description.list.point1"
            defaultMessage="Connecting to your CRM"
            description="Text of point 1 of video tutorial"
            key="point1"
          />,
          <FormattedMessage
            id="integrations.videoTutorial.description.list.point2"
            defaultMessage="Setting up record types and users"
            description="Text of point 2 of video tutorial"
            key="point2"
          />,
          <FormattedMessage
            id="integrations.videoTutorial.description.list.point3"
            defaultMessage="Mapping fields"
            description="Text of point 3 of video tutorial"
            key="point3"
          />,
          <FormattedMessage
            id="integrations.videoTutorial.description.list.point4"
            defaultMessage="Scheduling your integration"
            description="Text of point 4 of video tutorial"
            key="point4"
          />,
          <FormattedMessage
            id="integrations.videoTutorial.description.list.point5"
            defaultMessage="Modifying your integration"
            description="Text of point 5 of video tutorial"
            key="point5"
          />,
        ]}
      </VideoDescription>
    </VideoInfoModal>
  );
};

export default VideoTutorialModal;
